module.exports = __webpack_public_path__ + "static/img/image1.51f2c6f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/2023/0112/image1.jpeg
// module id = uCs5
// module chunks = 38